import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavbar from "./TopNavbar";
import {
  Search,
  Coins,
  Puzzle,
  Rocket,
  Gamepad2,
  Crown,
  X,
} from "lucide-react";
import { motion } from "framer-motion";
import SignupModal from "./SignupModal";
import LoginModal from "./LoginModal";
import AdsterraBanner from "./Components/Anuncios/AdsterraBanner";
import ResponsiveAdBanner from "./Components/Anuncios/ResponsiveAdBanner";
import PopunderScript from "./Components/Anuncios/PopunderScript";

const categories = [
  { label: "All", color: "bg-orange-500", icon: "📦" },
  { label: "Action", color: "bg-blue-500", icon: "⚔️" },
  { label: "Arcade", color: "bg-pink-500", icon: "🕹️" },
  { label: "Adventure", color: "bg-sky-500", icon: "🚀" },
  { label: "Puzzles", color: "bg-yellow-500", icon: "🧩" },
];

const trendingGames = [
  { name: "Zap Aliens", image: "/Imagenes/games/ZapAliens.png", url: "/zap_alliens/zap-aliens-html5/game/index.html", category: "Action" },
  { name: "Dunk Shot", image: "/Imagenes/games/dunk-shot.png", url: "https://games.gogames.io/en/dunk-shot/index.html", category: "Action" },
  { name: "Guns & Bottles", image: "/Imagenes/games/gun.png", url: "https://games.gogames.io/gogames/en/guns-n-bottles/index.html", category: "Action" },
  { name: "Astro Run", image: "/Imagenes/games/AstroRun.png", url: "https://games.gogames.io/gogames/en/astro-run/index.html", category: "Action" },
   { name: "Amigos", image: "/Imagenes/games/Amigos.png", url: "https://games.gogames.io/gogames/en/amigoes/index.html", category: "Adventure" },
  { name: "Merge Fruit", image: "/Imagenes/games/mergefruit.png", url: "/mergefruits/index.html", category: "Arcade" },
  { name: "Tetris Colorido", image: "/Imagenes/games/tetrisn.png", url: "/tetris/index.html", category: "Arcade" },

  { name: "Pipe Mania", image: "/Imagenes/games/pipe.png", url: "https://games.gogames.io/gogames/en/pipe-mania/index.html", category: "Arcade" },
  { name: "Pirateship Shootout", image: "/Imagenes/games/pirate.png", url: "https://games.gogames.io/gogames/en/pirateship-shootout/index.html", category: "Action" },
  { name: "Cheese Ninja", image: "/Imagenes/games/ninja.png", url: "https://games.gogames.io/gogames/en/cheese-ninja/index.html", category: "Action" },

  { name: "Tiny Defende", image: "/Imagenes/games/tinydefende.png", url: "https://games.gogames.io/gogames/en/tiny-defender/index.html", category: "Action" },
 
  { name: "Caveman Adventures", image: "/Imagenes/games/CavemanAdventures.png", url: "https://games.gogames.io/gogames/en/caveman-adventures/index.html", category: "Adventure" },
  { name: "3d Puzzle", image: "/Imagenes/games/3dpuzzle.png", url: "https://games.gogames.io/gogames/en/3d-puzzle/index.html", category: "Puzzles" },
  { name: "Slider Puzzle", image: "/Imagenes/games/sliderpuzzle.png", url: "https://games.gogames.io/gogames/en/slider-puzzle/index.html", category: "Puzzles" },
  { name: "Memory Order", image: "/Imagenes/games/memoryorder.png", url: "https://games.gogames.io/gogames/en/memory-order/index.html", category: "Puzzles" },
  { name: "Get Twelve", image: "/Imagenes/games/Twelve.png", url: "https://html5.gamedistribution.com/5fb9b774831843009ff37110468373d9/?gd_sdk_referrer_url=https://pixartplay.com/juegos", category: "Arcade" },
  { name: "Tetris Neo", image: "/Imagenes/games/tetris.png", url: "/tetris-neo/index.html", category: "Arcade" },
  {name: "Jungle", image: "/Imagenes/games/Jungle.png", url: "/jungle/index.html", category: "Adventure"},
  { name: "Cut The Fruit", image: "https://games.gogames.io/gogames/en/cut-the-fruit/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/cut-the-fruit/index.html", category: "Action" },
  { name: "Gems Shooter", image: "https://games.gogames.io/gogames/en/gems-shooter/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/gems-shooter/index.html", category: "Arcade" },
  { name: "Hexagon Fall", image: "https://games.gogames.io/gogames/en/hexagon-fall/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/hexagon-fall/index.html", category: "Action" },
  { name: "Hit The Knife", image: "https://games.gogames.io/gogames/en/hit-the-knife/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/hit-the-knife/index.html", category: "Action" },
  { name: "Jelly Jump", image: "https://games.gogames.io/gogames/en/jelly-jump/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/jelly-jump/index.html", category: "Arcade" },
  { name: "Ninja Shape", image: "https://games.gogames.io/gogames/en/ninja-shape/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/ninja-shape/index.html", category: "Action" },
  { name: "Rush Box", image: "https://games.gogames.io/gogames/en/rush-box/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/rush-box/index.html", category: "Arcade" },
  { name: "Saloon Shootout", image: "https://games.gogames.io/gogames/en/saloon-shootout/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/saloon-shootout/index.html", category: "Action" },
  { name: "Spacebox", image: "https://games.gogames.io/gogames/en/spacebox/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/spacebox/index.html", category: "Action" },
  { name: "Speedy Boat", image: "https://games.gogames.io/gogames/en/speedy-boat/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/speedy-boat/index.html", category: "Action" },
  { name: "Stick Monkey", image: "https://games.gogames.io/gogames/en/stick-monkey/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/stick-monkey/index.html", category: "Action" },
  { name: "Swing Robber", image: "https://games.gogames.io/gogames/en/swing-robber/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/swing-robber/index.html", category: "Action" },
  { name: "Swipe", image: "https://games.gogames.io/gogames/en/swipe/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/swipe/index.html", category: "Action" },
  { name: "Swipe Color", image: "https://games.gogames.io/gogames/en/swipe-color/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/swipe-color/index.html", category: "Action" },
  { name: "Thank You Santa", image: "https://games.gogames.io/gogames/en/thank-you-santa/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/thank-you-santa/index.html", category: "Arcade" },
  { name: "Ticked Block", image: "https://games.gogames.io/gogames/en/ticked-block/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/ticked-block/index.html", category: "Puzzles" },
  { name: "Traffic", image: "https://games.gogames.io/gogames/en/traffic/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/traffic/index.html", category: "Action" },
  { name: "True Number", image: "https://games.gogames.io/gogames/en/true-number/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/true-number/index.html", category: "Puzzles" },
  { name: "Tipsy Card", image: "https://go-games.gg/assets/default_thumbnail-RniWwWco.jpg", url: "https://games.gogames.io/gogames/en/tipsy-card/index.html", category: "Puzzles" },

  
  { name: "Great Air Battles", image: "https://games.gogames.io/gogames/en/great-air-battles/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/great-air-battles/index.html", category: "Action" },
  { name: "Halloween Night", image: "https://games.gogames.io/gogames/en/halloween-night/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/halloween-night/index.html", category: "Adventure" },
  { name: "Ninja Action 2", image: "https://games.gogames.io/gogames/en/ninja-action-2/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/ninja-action-2/index.html", category: "Action" },
  { name: "Santa or Thief", image: "https://games.gogames.io/gogames/en/santa-or-thief/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/santa-or-thief/index.html", category: "Action" },
  { name: "Yeti Sensation", image: "https://games.gogames.io/gogames/en/yeti-sensation/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/yeti-sensation/index.html", category: "Adventure" },
  { name: "Tipsy Dice", image: "https://games.gogames.io/gogames/en/tipsy-dice/thumbs/Banner.jpg", url: "https://games.gogames.io/gogames/en/tipsy-dice/index.html", category: "Puzzles" },
  { name: "Wall Breaker", image: "https://games.gogames.io/gogames/en/wall-breaker/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/wall-breaker/index.html", category: "Action" },



  { name: "Jungle Mania", image: "https://games.gogames.io/gogames/en/jungle-mania/thumbs/icon-256.jpg", url: "https://games.gogames.io/gogames/en/jungle-mania/index.html", category: "Adventure" },
  { name: "Maze Lover", image: "https://games.gogames.io/gogames/en/maze-lover/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/maze-lover/index.html", category: "Arcade" },
  { name: "Space Bubbles", image: "https://games.gogames.io/gogames/en/space-bubbles/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/space-bubbles/index.html", category: "Arcade" },
  { name: "The Highest", image: "https://games.gogames.io/gogames/en/the-highest/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/the-highest/index.html", category: "Arcade" },

  { name: "Batting Challenge", image: "https://games.gogames.io/gogames/en/batting-challenge/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/batting-challenge/index.html", category: "Action" },
  { name: "Metal PinBall", image: "https://games.gogames.io/gogames/en/metal-pinball/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/metal-pinball/index.html", category: "Arcade" },
  { name: "Neon Hockey", image: "https://games.gogames.io/gogames/en/neon-hockey/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/neon-hockey/index.html", category: "Arcade" },
  { name: "Reversi", image: "https://games.gogames.io/gogames/en/reversi/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/reversi/index.html", category: "Puzzles" },
  { name: "Stickman Pong", image: "https://games.gogames.io/gogames/en/stickman-pong/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/stickman-pong/index.html", category: "Action" },
  { name: "Street Cricket", image: "https://games.gogames.io/gogames/en/street-cricket/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/street-cricket/index.html", category: "Action" },
  { name: "Tap Wheels", image: "https://games.gogames.io/gogames/en/tap-wheels/thumbs/icon-256.png", url: "https://games.gogames.io/gogames/en/tap-wheels/index.html", category: "Arcade" }



  

];

const GamesScreen = () => {
  const navigate = useNavigate();
  const [showSignup, setShowSignup] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [selectedGameUrl, setSelectedGameUrl] = useState(null);
  const [showCountdown, setShowCountdown] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All"); // Estado para la categoría seleccionada


  useEffect(() => {
    if (showCountdown && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (showCountdown && countdown === 0) {
      setShowCloseButton(true);
    }
  }, [showCountdown, countdown]);

  // Effect to load and clean up the Adsterra script
  useEffect(() => {
    if (showCountdown) {
      const scriptId = 'adsterra-social-bar-script';
      if (document.getElementById(scriptId)) {
        return; // Script already loaded
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = "https://pl28457202.effectivegatecpm.com/25/a0/71/25a071f557db1f342cd32743973b201d.js";
      script.async = true;
      document.body.appendChild(script);

                  // Cleanup function to remove the script when the component unmounts or countdown is hidden
                return () => {
                  const existingScript = document.getElementById(scriptId);
                  if (existingScript) {
                    existingScript.remove();
                  }
                  // Ad scripts can sometimes leave other elements behind, which are harder to track.
                  // This cleanup is the most reliable first step.
                };
              }
            }, [showCountdown]);



  const handleGameClick = (url) => {
    setSelectedGameUrl(url);
    setShowCountdown(true);
    setCountdown(4);
    setShowCloseButton(false);
  };

  const filteredGames = selectedCategory === "All"
    ? trendingGames
    : trendingGames.filter(game => game.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white flex flex-col overflow-x-hidden">
      <TopNavbar
        onSignUpClick={() => setShowSignup(true)}
        onLoginClick={() => setShowLogin(true)}
      />

      <SignupModal
        isOpen={showSignup}
        onClose={() => setShowSignup(false)}
        onSwitchToLogin={() => {
          setShowSignup(false);
          setShowLogin(true);
        }}
      />
      <LoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSwitchToSignup={() => {
          setShowLogin(false);
          setShowSignup(true);
        }}
      />

      <PopunderScript />
	  
 {/*barra de la izquierda*/}
	
      <div className="flex flex-1 overflow-hidden">
        <div className="hidden sm:flex bg-white/5 text-white backdrop-blur-lg shadow-md h-full py-6 px-4 flex-col items-center gap-6 overflow-hidden border-r border-white/10">
          <button onClick={() => navigate('/juegos')} className="p-2 rounded-lg hover:bg-white/10 transition text-blue-400" title="Juegos">
            <Gamepad2 size={24} />
          </button>
          <button onClick={() => navigate('/torneos/zap-aliens')} className="p-2 rounded-lg hover:bg-white/10 transition" title="Torneos">
            <Crown size={24} />
          </button>
        </div>

        <div className="fixed bottom-0 left-0 right-0 w-full bg-white/5 backdrop-blur-lg shadow-inner border-t border-white/10 sm:hidden z-50">
          <div className="max-w-md mx-auto flex justify-around items-center py-3 text-white text-sm">
            <button onClick={() => navigate('/juegos')} className="flex flex-col items-center text-blue-400">
              <Gamepad2 size={20} />
              <span className="text-xs mt-1">Juegos</span>
            </button>
            <button onClick={() => navigate('/torneos/zap-aliens')} className="flex flex-col items-center">
              <Crown size={20} />
              <span className="text-xs mt-1">Torneos</span>
            </button>
          </div>
        </div>

        <div className="flex-1 px-6 py-8 space-y-10 overflow-y-auto pb-20">
          {/* Banner superior */}
          <ResponsiveAdBanner position="top" />
          
          {/* <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-4 py-3 backdrop-blur-md">
            <Search size={20} className="text-gray-400" />
            <input
              type="text"
              placeholder="Search"
              className="bg-transparent outline-none w-full text-white placeholder-gray-400"
            />
          </div> */}

          <div>
            <h2 className="text-2xl font-bold mb-4">Categories</h2>
            <div className="flex gap-4 overflow-x-auto scrollbar-hide">
              {categories.map((cat) => (
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  key={cat.label}
                  onClick={() => setSelectedCategory(cat.label)} // Manejador de clic
                  className={`min-w-[120px] rounded-xl px-4 py-4 text-center ${cat.color} text-white font-semibold text-sm flex flex-col items-center shadow-lg backdrop-blur-md cursor-pointer
                    ${selectedCategory === cat.label ? 'ring-2 ring-blue-400 scale-105' : ''}`} // Estilo para la categoría seleccionada
                >
                  <div className="text-2xl">{cat.icon}</div>
                  {cat.label}
                </motion.div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-4">Trending Games</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
              {filteredGames.map((game, index) => ( // Renderizar juegos filtrados
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  key={game.name}
                  onClick={() => handleGameClick(game.url)}
                  className="rounded-xl overflow-hidden shadow-lg cursor-pointer bg-white/5 border border-white/10 backdrop-blur-md"
                >
                  <img
                    src={game.image}
                    alt={game.name}
                    className="w-full h-28 object-cover"
                  />
                  <div className="p-2 text-sm font-medium text-white text-center">
                    {game.name}
                  </div>
                </motion.div>
              ))}

              {/*<div className="col-span-2 md:col-span-3 lg:col-span-6">
                <ResponsiveAdBanner position="middle" />
              </div>*/}
            </div>
          </div>

          <ResponsiveAdBanner position="bottom" />

          {/*<div className="flex justify-center mt-4">
            <AdsterraBanner />
          </div>*/}
        </div>
      </div>

      {selectedGameUrl && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex justify-center items-center flex-col">
          <div className="relative w-full max-w-5xl h-[80vh]">
            <iframe
              src={selectedGameUrl}
              title="Juego"
              className="w-full h-full rounded-xl border-none"
              allowFullScreen
            ></iframe>

            <button
              onClick={() => setSelectedGameUrl(null)}
              className="absolute top-12 left-0 bg-white text-black px-6 py-4 rounded-r-full rounded-l-none font-bold flex items-center gap-1 z-[9999] shadow-md"
            >
              ←
            </button>

            {/* Vignette Monetag aislado en iframe. Al desmontar el countdown, muere todo con él. */}
            {showCountdown && (
              <iframe
                title="vignette-ad"
                srcDoc={`<!DOCTYPE html><html><body style="margin:0;padding:0;"><script>(function(s){s.dataset.zone='11277326',s.src='https://n6wxm.com/vignette.min.js'})([document.documentElement, document.body].filter(Boolean).pop().appendChild(document.createElement('script')))</script></body></html>`}
                style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', border: 0, zIndex: 9999 }}
              />
            )}

            {/* Countdown Overlay */}
            {showCountdown && (
              <div className="absolute inset-0 flex items-center justify-center z-[10000]">
                <div className="w-4/5 h-4/5 bg-black bg-opacity-95 rounded-lg flex flex-col items-center justify-center relative shadow-2xl">
                  <h2 className="text-white text-4xl font-bold mb-4 text-center px-4">
                    El juego comenzará en:
                  </h2>
                  {/*
                    ----------------------------------------------------------------------
                      BLOQUE DE PUBLICIDAD EN PANTALLA DE CARGA
                      Este bloque contiene el script de la Social Bar de Adsterra.
                      El script se cargará cuando se muestre la pantalla de carga del juego.
                    ----------------------------------------------------------------------
                  */}

                  {/* --- FIN BLOQUE DE PUBLICIDAD --- */}
                  <p className="text-white text-6xl font-mono mb-8">{countdown}</p>
                  {showCloseButton && (
                    <button
                      onClick={() => setShowCountdown(false)}
                      className="absolute top-4 right-4 text-white hover:text-gray-300"
                    >
                      <X size={40} />
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Banner inferior mientras se juega */}
          <div className="mt-4 w-full flex justify-center z-50">
            <ResponsiveAdBanner position="game" />
          </div>
        </div>
      )}
    </div>
  );
};

export default GamesScreen;
